import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Videos from "../components/Videos";
import VideoTags from "../components/TeacherVideoTags";
import TeacherProfileNav from "../components/TeacherProfileNav";
import home from "../images/home.png";
import feedback from "../images/feedback.png";
import history from "../images/history.png";
import tutorials from "../images/tutorials.png";
import TeacherProfileHeader from "../components/TeacherProfileHeader";
// import teacherVideoData from "../components/TeacherVideoData";
import "../styles/TeacherDashboard.css";
import { getUserID } from "../Storage/Storage";
import { teacherVideos } from "../Services/AllServices";

const TeacherDashboard = () => {
  const [activeItem, setActiveItem] = useState("home");
  const [isVideoMode, setIsVideoMode] = useState(true);
  const [showUploadForm, setShowUploadForm] = useState(false);
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [videoData, setVideoData] = useState([]);

  useEffect(() => {
    if (showUploadForm) {
      navigate("/teacher/upload");
    }

    const fetchTeacherVideos = async () => {
      try {
        const userId = await getUserID(); // Fetch user ID from storage

        // Fetch user profile based on user ID
        const formData = { user_id: userId };

        await teacherVideos(formData, (response) => {
          if (response && response.status === "success") {
            // console.log("Teacher Videos:", response);
            if (Array.isArray(response.data.videos_data)) {
              setVideoData(response.data.videos_data);
            } else {
              console.error("Data is not an array:", response);
            }
          }
        });
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchTeacherVideos();
  }, [showUploadForm, navigate]);

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  const resetSearch = () => {
    setSearchQuery(""); // Reset the search query
    setIsSearching(false); // Reset search mode
  };

  const teacherMenuItems = [
    { icon: home, label: "Home", key: "home" },
    { icon: feedback, label: "Feedback", key: "feedback" },
    { icon: tutorials, label: "Tutorials", key: "tutorials", disabled: true },
    { icon: history, label: "History", key: "history", disabled: true },
  ];

  // Determine which parts of the header to show based on the active menu item
  const getHeaderVisibility = () => {
    if (activeItem === "home" || activeItem === "") {
      return { showSearch: true, showToggle: true, showUserProfile: true };
    } else if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    } else if (activeItem === "tutorials") {
      return { showSearch: true, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };
  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item

    // Navigate to the correct route
    if (item === "feedback") {
      navigate("/teacherFeedback"); // Navigate to feedback page
    } else if (item === "home") {
      navigate("/teacher"); // Navigate to home page
    } else if (item === "tutorials") {
      navigate("/teacher/tutorials");
    }

    resetSearch(); // Reset search whenever a new section is selected
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setIsSearching(query.length > 0); // Show "Search Results" tab if search query exists
    setActiveItem(""); // No active menu item during search
  };

  const filteredVideos = videoData.filter((video) =>
    video.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="dashboard">
      <Header
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
        searchQuery={searchQuery}
        onSearch={handleSearch}
      />
      <main className="main-content">
        <Sidebar
          activeItem={activeItem}
          setActiveItem={handleActiveItemChange}
          menuItems={teacherMenuItems}
          resetSearch={resetSearch}
        />
        <div className="content">
          <div className="teacher_user_profile">
            <TeacherProfileHeader
              showUploadForm={showUploadForm}
              setShowUploadForm={setShowUploadForm}
            />
            <VideoTags />
            <TeacherProfileNav
              setSearchQuery={setSearchQuery}
              setIsSearching={setIsSearching}
              isSearching={isSearching}
              filteredVideos={filteredVideos}
              isDownloadPage={false}
            />
          </div>
          {isSearching ? (
            <Videos videoData={filteredVideos} />
          ) : (
            <Videos videoData={videoData} />
          )}
        </div>
      </main>
    </div>
  );
};

export default TeacherDashboard;
